module.exports = __webpack_public_path__ + "../resources/img/ic_tooltip_arrow.26831026.svg";